import { CommonModule } from '@angular/common';
import { ApiService } from 'src/app/Services/api.service';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { finalize, take } from 'rxjs';
import { ConfirmActionModalComponent } from 'src/app/Modals/confirm-action-modal/confirm-action-modal.component';


@Component({
  selector: 'app-reset-aiia-integration',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './reset-aiia-integration.component.html',
  styleUrls: ['./reset-aiia-integration.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResetAiiaIntegrationComponent implements OnInit {
  @Input() integrationId : string;
  @Input() disabled = false;

  isLoading = false;
  errorMessage: string | null = null;
  successMessage: string | null = null;
  constructor(
    private api: ApiService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
  }

  resetAiiaIntegration():void {
    if (!this.integrationId) return ;

    const dialogRef = this.dialog.open(ConfirmActionModalComponent, {
      data: {
        pageTitle: 'Återställ Aiia-integration',
        pageBody:
          'Är du säker på att du vill återställa kundens Aiia-integration? Alla kopplade bankkonton kommer att tas bort.',
        confirmButton: 'Återställ',
        confirmButtonColor: '#c93f34',
      },
    });

    dialogRef.componentInstance.confirmAction.subscribe(() => {
      this.isLoading = true;
      this.successMessage = null;
      this.errorMessage = null;
      this.cdr.markForCheck();

      this.api.resetAiiaIntegration(this.integrationId).pipe(
        take(1),
        finalize(() => {
          this.isLoading = false;
          this.cdr.markForCheck();
        })
      ).subscribe({
        next: () => {
            this.successMessage= 'Aiia-integrationen är nollställd.';
            this.integrationId = null;
            this.cdr.markForCheck();
        },
      error: (err) => {
        this.errorMessage = err?.error?.message || err?.message || 'Ett fel uppstod.';
        this.cdr.markForCheck();
        }
      });
    });
  }
}
